export default {
  goodRemains(state) {
    return state.goodRemains
  },
  goodRemainFilters(state) {
    return state.goodRemainFilters
  },
  goodRemain(state) {
    return state.goodRemain
  },
  goodRemainHistory(state) {
    return state.goodRemainHistory
  },
}
